module.exports = __webpack_public_path__ + "static/thank-you-ae5ae017e7b940850be4058dc79130be.gif";